import { render } from "./LoadingScreen.vue?vue&type=template&id=155b3626&scoped=true&ts=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=155b3626&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155b3626"]])

export default __exports__